import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PrimaryButton } from '@shared/components/ui';
import React from 'react';

interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  open,
  onClose,
  title = 'Ocurrió un error',
  message,
  confirmText = 'Aceptar',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{ paper: { sx: { borderRadius: '16px' } } }}>
      <DialogTitle sx={{ fontWeight: 700, fontSize: '22px', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 32 }} />
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        {message ? (
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {message}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5, '& .MuiButton-root': { minWidth: 140 } }}>
        <PrimaryButton variant="contained" onClick={onClose}>
          {confirmText}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
